<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <div class="text-block text-center position-relative">
        <h1 class="page-heading">{{ $t('PostProgram.ProgramEndedTitle') }}</h1>
      </div>
      <p v-html="$t('PostProgram.ProgramEndedDesc')"></p>
      <p class="my-5 text-center">
        <a href="https://www.frostedflakes.us/mission-tiger/ " target="_blank" class="btn-link">CONTINUE EXPLORING MISSION TIGER</a>
      </p>
    </div>
  </main>
</template>
<script>
export default {
  props: {
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
